window.addEventListener('load', () => {
  document.querySelectorAll('.gallery-desktop-carousel').forEach(carousel => {
    const track = carousel.querySelector('.gallery');
    if (!track) return;

    let isPointerDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let lastX = 0;
    let velocity = 0;
    let momentumID = null;
    let lastTime = 0;

    const stopMomentum = () => {
      cancelAnimationFrame(momentumID);
      momentumID = null;
    };

    const momentumScroll = () => {
      track.scrollLeft -= velocity;
      velocity *= 0.95; // smooth decay
      if (Math.abs(velocity) > 0.4) {
        momentumID = requestAnimationFrame(momentumScroll);
      }
    };

    const startDrag = clientX => {
      isPointerDown = true;
      track.classList.add('is-dragging');
      startX = clientX;
      scrollLeft = track.scrollLeft;
      lastX = clientX;
      lastTime = Date.now();
      stopMomentum();
    };

    const moveDrag = clientX => {
      if (!isPointerDown) return;
      const dx = clientX - startX;
      track.scrollLeft = scrollLeft - dx * 1.8; // stronger drag multiplier

      const now = Date.now();
      const deltaX = clientX - lastX;
      const deltaTime = now - lastTime;
      velocity = (deltaX / deltaTime) * 20; // flick strength
      lastX = clientX;
      lastTime = now;
    };

    const endDrag = () => {
      if (!isPointerDown) return;
      isPointerDown = false;
      track.classList.remove('is-dragging');
      momentumScroll();
    };

    // ---- Pointer Events ----
    track.addEventListener('pointerdown', e => {
      // Only allow left-click drag on desktop
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      track.setPointerCapture(e.pointerId);
      startDrag(e.clientX);
    });

    track.addEventListener('pointermove', e => {
      if (!isPointerDown) return;
      e.preventDefault(); // stop native text/image drag
      moveDrag(e.clientX);
    });

    track.addEventListener('pointerup', e => {
      track.releasePointerCapture(e.pointerId);
      endDrag();
    });

    track.addEventListener('pointercancel', endDrag);

    // ---- Touch Events (for Safari / iOS) ----
    track.addEventListener('touchstart', e => {
      startDrag(e.touches[0].clientX);
    }, { passive: true });

    track.addEventListener('touchmove', e => {
      moveDrag(e.touches[0].clientX);
    }, { passive: false });

    track.addEventListener('touchend', endDrag);
  });
});
